export default "__VITE_ASSET__4e1bc92d__"